<template>
  <el-row class="full-screen">
    <el-input
      v-model="search"
      size="mini"
      class="search"
      :placeholder="$t('user.tableHeader.search')"/>
      <br><br>
    <el-table
      :data="usersLogin.filter(item => !search || ( item.username.toLowerCase().includes(search.toLowerCase()) ) || ( item.email.toLowerCase().includes(search.toLowerCase()) )  )"
      style="width: 100%"
      height="100vh"
      ref="usersTable"
    >
      <!--el-table-column
        type="expand">
        <template slot-scope="props">
          <user-info :user="props" v-if="isAdmin"/>
          <user-info-simple :user="props"  v-else/>
        </template>
      </el-table-column-->
      <el-table-column
        :label="$t('user.tableHeader.username')"
        prop=username>
      </el-table-column>
      <el-table-column
        :label="$t('user.tableHeader.email')"
        width="200"
        prop=email>
      </el-table-column>
      <el-table-column
        label="Последний вход"
        width="200"
        prop=last_login>
        <template #default="scope">{{scope.row.last_login.toLocaleString("ru-RU")}}</template>
      </el-table-column>
      <el-table-column
        label="Количество авторизаций"
        prop=auth
        width="200">
              <el-table-column prop="day" label="День" max-width="50">
              </el-table-column>
              <el-table-column prop="week" label="Неделя" max-width="50"/>
              <el-table-column prop="month" label="Месяц" max-width="50"/>
      </el-table-column>
      <el-table-column
        prop="status"
        label="Статус"
        width="110"
        filter-placement="bottom-end"
      >
        <template #default="scope">
          <el-tag
            :type="!scope.row.status ? 'danger' : 'success'"
            disable-transitions
            > {{!scope.row.status ? "Неактивен" : "Активен"}}</el-tag
          >
        </template>
      </el-table-column>
    <!--el-table-column
        label="ip"
        prop=ip>
      </el-table-column>
      <el-table-column
        prop="status"
        label="Статус"
        width="110"
        filter-placement="bottom-end"
      >
        <template #default="scope">
          <el-tag
            :type="scope.row.status[0] != 0 || nowDate.getHours() - diffTime(scope.row.status).getHours() > 1 ? 'danger' : 'success'"
            disable-transitions
            > {{scope.row.status[0] != 0 || nowDate.getHours() - diffTime(scope.row.status).getHours() > 1 ? "Неактивен" : "Активен"}}</el-tag
          >
        </template>
      </el-table-column-->
    </el-table>
  </el-row>
</template>

<script>
  // vuex
  import { mapGetters } from "vuex";

  // store
  import { GET_USERS, GET_USERS_LOGIN } from "../../../../store/actions/users";

  // components
  import UserInfo from './UserInfo';
  import UserInfoSimple from './UserInfoSimple';

  const getRandomInt = (max) => {
    let randomDate = new Date()
    let date = Math.floor(Math.random() * 3)
    let time = getRandomHour(8, 21)
    if (date == 0)
      time = getRandomHour(8, randomDate.getHours());
    return [date, time];
  }

  const getRandomTime = (max) => {
    return Math.floor(Math.random() * 60);
  }

  const getRandomHour = (min, max) => {
    return Math.random() * (max - min) + min;
  }

  export default {
    name: 'Users',
    data() {
      return {
        search: '',
        nowDate: new Date(),
        roles: this.$t('user.roles'),
        /*users: [
    {
        username: "zhil_kom_spb",
        email: "zhil_kom_spb@gov.spb.ru",
        uid: "979",
        ip: "217.195.85.20 ",
        day: 1,
        week: 33,
        month: 85,
        status: getRandomInt(100)
    },
    {
        username: "kio_spb",
        email: "kio_spb@gov.spb.ru",
        uid: "955",
        ip: "37.230.144.250 ",
        day: 1,
        week: 14,
        month: 126,
        status: getRandomInt(100)
    },
    {
        username: "kom_sp_spb",
        email: "kom_sp_spb@gov.spb.ru",
        uid: "1002",
        ip: "5.16.62.71 ",
        day: 3,
        week: 29,
        month: 114,
        status: getRandomInt(100)
    },
    {
        username: "gati_spb",
        email: "gati_spb@gov.spb.ru",
        uid: "1013",
        ip: "217.195.78.214 ",
        day: 2,
        week: 25,
        month: 103,
        status: getRandomInt(100)   
    },
    {
        username: "kom_kontr_im",
        email: "kom_kontr_im@gov.spb.ru",
        uid: "991",
        ip: "94.131.98.84 ",
        day: 2,
        week: 24,
        month: 66,
        status: getRandomInt(100)
    },
    {
        username: "kom_fin_spb",
        email: "kom_fin_spb@gov.spb.ru",
        uid: "1012",
        ip: "194.50.24.4 ",
        day: 2,
        week: 32,
        month: 53,
        status: getRandomInt(100)   
    },
    {
        username: "kom_ppit_spb",
        email: "kom_ppit_spb@gov.spb.ru",
        uid: "999",
        ip: "5.3.191.105 ",
        day: 3,
        week: 34,
        month: 75,
        status: getRandomInt(100)
    },
    {
        username: "Kom_pvsmi",
        email: "Kom_pvsmi@gov.spb.ru",
        uid: "997",
        ip: "176.15.252.236 ",
        day: 1,
        week: 16,
        month: 32,
        status: getRandomInt(100)   
    },
    {
        username: "kom_gra",
        email: "kom_gra@gov.spb.ru",
        uid: "986",
        ip: "31.134.189.182 ",
        day: 1,
        week: 31,
        month: 100,
        status: getRandomInt(100)  
    },
    {
        username: "kom_kilt_spb",
        email: "kom_kilt_spb@gov.spb.ru",
        uid: "992",
        ip: "104.28.196.107 ",
        day: 3,
        week: 9,
        month: 30,
        status: getRandomInt(100)        
    },
    {
        username: "Razumishkinvg.gov.spb.ru",
        email: "Razumishkin@vg.gov.spb.ru",
        uid: "1139",
        ip: "178.66.149.44 ",
        day: 2,
        week: 13,
        month: 44,
        status: getRandomInt(100)        
    },
    {
        username: "piotrovskygov.spb.ru",
        email: "piotrovsky@gov.spb.ru",
        uid: "1072",
        ip: "104.28.196.108 ",
        day: 2,
        week: 27,
        month: 71,
        status: getRandomInt(100)       
    },
    {
        username: "kom_rt_spb",
        email: "kom_rt_spb@gov.spb.ru",
        uid: "1001",
        ip: "89.223.50.75 ",
        day: 1,
        week: 23,
        month: 34,
        status: getRandomInt(100)        
    },
    {
        username: "admin_petrodvor_spb",
        email: "admin_petrodvor_spb@gov.spb.ru",
        uid: "973",
        ip: "92.62.57.113 ",
        day: 1,
        week: 21,
        month: 88,
        status: getRandomInt(100)        
    },
    {
        username: "admin_krasn_spb",
        email: "admin_krasn_spb@gov.spb.ru",
        uid: "966",
        ip: "178.66.128.233",
        day: 1,
        week: 31,
        month: 76,
        status: getRandomInt(100)       
    },
    {
        username: "aleksandrglassen-it.com",
        email: "aleksandr@glassen-it.com",
        uid: "1171",
        ip: "69.99.75.2",
        day: "2",
        week: "22",
        month: "79 ",
        status:  getRandomInt(100)
    },
    {
        username: "g.cherepanovglassen-it.com",
        email: "g.cherepanov@glassen-it.com",
        uid: "1141",
        ip: "89.123.30.147",
        day: "1",
        week: "10",
        month: "30 ",
        status:  getRandomInt(100)
    },
    {
        username: "lk_kazancom",
        email: "lk_kazan@com",
        uid: "1168",
        ip: "5.122.162.87",
        day: "2",
        week: "18",
        month: "89 ",
        status:  getRandomInt(100)
    },
    {
        username: "m.podmarevglassen-it.com",
        email: "m.podmarev@glassen-it.com",
        uid: "1075",
        ip: "106.61.104.228",
        day: "4",
        week: "24",
        month: "78 ",
        status:  getRandomInt(100)
    },
    {
        username: "pavelglassen-it.com",
        email: "pavel@glassen-it.com",
        uid: "1172",
        ip: "75.116.99.241",
        day: "2",
        week: "27",
        month: "35 ",
        status:  getRandomInt(100)
    },
    {
        username: "vladaglassen-it.com",
        email: "vlada@glassen-it.com",
        uid: "1169",
        ip: "129.174.180.219",
        day: "2",
        week: "17",
        month: "49 ",
        status:  getRandomInt(100)
    },
    {
        username: "megamarketmarketplace.com",
        email: "megamarket@marketplace.com",
        uid: "1167",
        ip: "74.94.119.19",
        day: "4",
        week: "29",
        month: "124 ",
        status:  getRandomInt(100)
    },
    {
        username: "test.kis.gov.spb.ru",
        email: "test@kis.gov.spb.ru",
        uid: "937",
        ip: "234.219.79.49",
        day: "3",
        week: "19",
        month: "39 ",
        status:  getRandomInt(100)
    },
    {
        username: "turizmglassen-it.com",
        email: "turizm@glassen-it.com",
        uid: "1077",
        ip: "226.40.184.229",
        day: "5",
        week: "24",
        month: "62 ",
        status:  getRandomInt(100)
    },
    {
        username: "kazakhstanglassen-it.com",
        email: "kazakhstan@glassen-it.com",
        uid: "1120",
        ip: "1.2.156.255",
        day: "3",
        week: "19",
        month: "39 ",
        status:  getRandomInt(100)
    },
    {
        username: "sergeyglassen-it.com",
        email: "sergey@glassen-it.com",
        uid: "1045",
        ip: "88.194.202.200",
        day: "1",
        week: "20",
        month: "101 ",
        status:  getRandomInt(100)
    },
    {
        username: "kapralovayarregion.ru",
        email: "kapralova@yarregion.ru",
        uid: "1198",
        ip: "205.211.24.17",
        day: "4",
        week: "9",
        month: "121 ",
        status:  getRandomInt(100)
    },
    {
        username: "bochkovayarregion.ru",
        email: "bochkova@yarregion.ru",
        uid: "1197",
        ip: "174.151.2.178",
        day: "5",
        week: "28",
        month: "119 ",
        status:  getRandomInt(100)
    },
    {
        username: "korotkovasayarregion.ru",
        email: "korotkovasa@yarregion.ru",
        uid: "1196",
        ip: "31.62.125.192",
        day: "4",
        week: "34",
        month: "106 ",
        status:  getRandomInt(100)
    },
    {
        username: "malyshevaebyarregion.ru",
        email: "malyshevaeb@yarregion.ru",
        uid: "1205",
        ip: "182.143.171.84",
        day: "3",
        week: "5",
        month: "69 ",
        status:  getRandomInt(100)
    },
    {
        username: "kolomazinanvyarregion.ru",
        email: "kolomazinanv@yarregion.ru",
        uid: "1202",
        ip: "232.107.188.161",
        day: "3",
        week: "29",
        month: "118 ",
        status:  getRandomInt(100)
    },
    {
        username: "kozelskaynvyarregion.ru",
        email: "kozelskaynv@yarregion.ru",
        uid: "1195",
        ip: "36.194.14.250",
        day: "2",
        week: "18",
        month: "93 ",
        status:  getRandomInt(100)
    },
    {
        username: "snow.yarmail.ru",
        email: "snow.yar@mail.ru",
        uid: "1190",
        ip: "172.201.17.161",
        day: "5",
        week: "14",
        month: "90 ",
        status:  getRandomInt(100)
    },
    {
        username: "prodvizhenietest.com",
        email: "prodvizhenie@test.com",
        uid: "1183",
        ip: "46.105.22.91",
        day: "4",
        week: "9",
        month: "66",
        status:  getRandomInt(100)
    },
    {
        username: "M.Borisenkoglassen-it.com",
        email: "M.Borisenko@glassen-it.com",
        uid: "1178",
        ip: "108.92.8.36",
        day: "2",
        week: "21",
        month: "101 ",
        status:  getRandomInt(100)
    },
    {
        username: "A.Metlitskayaglassen-it.com",
        email: "A.Metlitskaya@glassen-it.com",
        uid: "1174",
        ip: "156.215.107.212",
        day: "2",
        week: "24",
        month: "78 ",
        status:  getRandomInt(100)
    },
    {
        username: "k.polesskayaglassen-it.com",
        email: "k.polesskaya@glassen-it.com",
        uid: "1173",
        ip: "183.101.209.183",
        day: "4",
        week: "6",
        month: "97 ",
        status:  getRandomInt(100)
    },
    {
        username: "t.smirnovaglassen-it.com",
        email: "t.smirnova@glassen-it.com",
        uid: "1165",
        ip: "160.124.74.155",
        day: "1",
        week: "21",
        month: "72 ",
        status:  getRandomInt(100)
    },
    {
        username: "v.orlyanskayaglassen-it.com",
        email: "v.orlyanskaya@glassen-it.com",
        uid: "1164",
        ip: "72.184.75.19",
        day: "4",
        week: "32",
        month: "57 ",
        status:  getRandomInt(100)
    },
    {
        username: "PSB2psbank.ru",
        email: "PSB2@psbank.ru",
        uid: "1080",
        ip: "247.205.197.162",
        day: "3",
        week: "31",
        month: "121 ",
        status:  getRandomInt(100)
    },
    {
        username: "PSB",
        email: "PSB@psbank.ru",
        uid: "1079",
        ip: "13.121.0.221",
        day: "5",
        week: "9",
        month: "91 ",
        status:  getRandomInt(100)
    },
    {
        username: "Moderatorgov.spb.ru",
        email: "Moderator2@gov.spb.ru",
        uid: "1061",
        ip: "213.143.43.199",
        day: "4",
        week: "29",
        month: "35 ",
        status:  getRandomInt(100)
    },
    {
        username: "Moderator",
        email: "Moderator@gov.spb.ru",
        uid: "1058",
        ip: "152.134.64.206",
        day: "1",
        week: "16",
        month: "113 ",
        status:  getRandomInt(100)
    },
    {
        username: "Linchenkovg.gov.spb.ru",
        email: "Linchenko@vg.gov.spb.ru",
        uid: "1056",
        ip: "202.105.113.171",
        day: "5",
        week: "21",
        month: "100 ",
        status:  getRandomInt(100)
    },
    {
        username: "Potechinavg.gov.spb.ru",
        email: "Potechina@vg.gov.spb.ru",
        uid: "1055",
        ip: "119.102.156.153",
        day: "1",
        week: "33",
        month: "75 ",
        status:  getRandomInt(100)
    },
    {
        username: "Meiksinvg.gov.spb.ru",
        email: "Meiksin@vg.gov.spb.ru",
        uid: "1054",
        ip: "48.160.111.32",
        day: "3",
        week: "33",
        month: "25 ",
        status:  getRandomInt(100)
    },
    {
        username: "Pikalevvg.gov.spb.ru",
        email: "Pikalev@vg.gov.spb.ru",
        uid: "1053",
        ip: "144.131.150.29",
        day: "5",
        week: "33",
        month: "118 ",
        status:  getRandomInt(100)
    },
    {
        username: "appar_gub_spbgov.spb.ru",
        email: "appar_gub_spb@gov.spb.ru",
        uid: "1052",
        ip: "72.52.61.127",
        day: "4",
        week: "6",
        month: "20 ",
        status:  getRandomInt(100)
    },
    {
        username: "slobozhanvg.gov.spb.ru",
        email: "slobozhan@vg.gov.spb.ru",
        uid: "1047",
        ip: "207.105.81.146",
        day: "3",
        week: "16",
        month: "112 ",
        status:  getRandomInt(100)
    },
    {
        username: "korabelnikovgov.spb.ru",
        email: "korabelnikov@gov.spb.ru",
        uid: "1036",
        ip: "97.91.113.190",
        day: "3",
        week: "14",
        month: "66 ",
        status:  getRandomInt(100)
    },
    {
        username: "potapenkogov.spb.ru",
        email: "potapenko@gov.spb.ru",
        uid: "1035",
        ip: "176.80.50.220",
        day: "5",
        week: "17",
        month: "21 ",
        status:  getRandomInt(100)
    },
    {
        username: "A.Odintsova",
        email: "A.Odintsova@glassen-it.com",
        uid: "1028",
        ip: "181.168.111.142",
        day: "2",
        week: "27",
        month: "47 ",
        status:  getRandomInt(100)
    },
    {
        username: "upr_sp",
        email: "upr_sp@gov.spb.ru",
        uid: "1019",
        ip: "111.57.171.71",
        day: "4",
        week: "13",
        month: "76",
        status:  getRandomInt(100)
    },
        {
        username: "upr_rso_spb",
        email: "upr_rso_spb@gov.spb.ru",
        uid: "1018",
        ip: "233.71.18.225",
        day: "5",
        week: "14",
        month: "36 ",
        status:  getRandomInt(100)
    },
    {
        username: "upr_vet_spb",
        email: "upr_vet_spb@gov.spb.ru",
        uid: "1017",
        ip: "222.70.174.67",
        day: "3",
        week: "17",
        month: "37 ",
        status:  getRandomInt(100)
    },
    {
        username: "sgsn_spb",
        email: "sgsn_spb@gov.spb.ru",
        uid: "1016",
        ip: "86.48.83.136",
        day: "4",
        week: "5",
        month: "105 ",
        status:  getRandomInt(100)
    },
    {
        username: "gos_tehnadzor",
        email: "gos_tehnadzor@gov.spb.ru",
        uid: "1015",
        ip: "60.55.124.240",
        day: "1",
        week: "18",
        month: "80 ",
        status:  getRandomInt(100)
    },
    {
        username: "gos_zhil_spb",
        email: "gos_zhil_spb@gov.spb.ru",
        uid: "1014",
        ip: "131.46.192.241",
        day: "2",
        week: "20",
        month: "106 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_tr_spb",
        email: "kom_tr_spb@gov.spb.ru",
        uid: "1011",
        ip: "130.29.203.135",
        day: "3",
        week: "30",
        month: "94 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_del_arkt",
        email: "kom_del_arkt@gov.spb.ru",
        uid: "1010",
        ip: "129.29.220.20",
        day: "4",
        week: "29",
        month: "109 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_eio",
        email: "kom_eio@gov.spb.ru",
        uid: "1009",
        ip: "252.181.122.244",
        day: "1",
        week: "28",
        month: "93 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_epsp_spb",
        email: "kom_epsp_spb@gov.spb.ru",
        uid: "1008",
        ip: "0.193.204.31",
        day: "3",
        week: "13",
        month: "40 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_fks",
        email: "kom_fks@gov.spb.ru",
        uid: "1007",
        ip: "47.247.81.55",
        day: "2",
        week: "21",
        month: "96 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_tzn_spb",
        email: "kom_tzn_spb@gov.spb.ru",
        uid: "1006",
        ip: "90.19.212.125",
        day: "2",
        week: "18",
        month: "47 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_trans",
        email: "kom_trans@gov.spb.ru",
        uid: "1005",
        ip: "96.214.129.85",
        day: "5",
        week: "21",
        month: "26 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_potar_spb",
        email: "kom_potar_spb@gov.spb.ru",
        uid: "1004",
        ip: "245.241.152.51",
        day: "5",
        week: "21",
        month: "20 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_stroy",
        email: "kom_stroy@gov.spb.ru",
        uid: "1003",
        ip: "58.54.223.235",
        day: "3",
        week: "19",
        month: "24 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_rti_spb",
        email: "kom_rti_spb@gov.spb.ru",
        uid: "1000",
        ip: "160.117.31.194",
        day: "5",
        week: "13",
        month: "84 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_poos_spb",
        email: "kom_poos_spb@gov.spb.ru",
        uid: "998",
        ip: "93.138.19.185",
        day: "2",
        week: "33",
        month: "24 ",
        status:  getRandomInt(100)
    },
    {
        username: "Kom_pvsmi",
        email: "Kom_pvsmi@gov.spb.ru",
        uid: "997",
        ip: "217.131.13.0",
        day: "2",
        week: "7",
        month: "29 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_obraz",
        email: "kom_obraz@gov.spb.ru",
        uid: "996",
        ip: "229.185.50.181",
        day: "2",
        week: "26",
        month: "51 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_nvh",
        email: "kom_nvh@gov.spb.ru",
        uid: "995",
        ip: "40.61.143.146",
        day: "3",
        week: "26",
        month: "111",
        status:  getRandomInt(100)
    },
    {
        username: "kom_mpvoo",
        email: "kom_mpvoo@gov.spb.ru",
        uid: "994",
        ip: "53.32.130.110",
        day: "5",
        week: "6",
        month: "39 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_mormp_spb",
        email: "kom_mormp_spb@gov.spb.ru",
        uid: "993",
        ip: "243.98.236.6",
        day: "4",
        week: "33",
        month: "70 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_dzags",
        email: "kom_dzags@gov.spb.ru",
        uid: "990",
        ip: "125.230.86.224",
        day: "4",
        week: "15",
        month: "58 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_inf_zvyaz",
        email: "kom_inf_zvyaz@gov.spb.ru",
        uid: "989",
        ip: "116.225.198.174",
        day: "3",
        week: "5",
        month: "57 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_invest_spb",
        email: "kom_invest_spb@gov.spb.ru",
        uid: "988",
        ip: "214.238.75.251",
        day: "2",
        week: "33",
        month: "45 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_gkiop_spb",
        email: "kom_gkiop_spb@gov.spb.ru",
        uid: "985",
        ip: "186.29.103.184",
        day: "3",
        week: "9",
        month: "55 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_gz_spb",
        email: "kom_gz_spb@gov.spb.ru",
        uid: "984",
        ip: "254.22.77.119",
        day: "1",
        week: "9",
        month: "105 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_vzp_spb",
        email: "kom_vzp_spb@gov.spb.ru",
        uid: "983",
        ip: "232.157.176.52",
        day: "3",
        week: "8",
        month: "82 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_vs_spb",
        email: "kom_vs_spb@gov.spb.ru",
        uid: "982",
        ip: "230.157.40.192",
        day: "3",
        week: "8",
        month: "93 ",
        status:  getRandomInt(100)
    },
    {
        username: "kom_b_spb",
        email: "kom_b_spb@gov.spb.ru",
        uid: "981",
        ip: "8.46.143.238",
        day: "5",
        week: "8",
        month: "92 ",
        status:  getRandomInt(100)
    },
    {
        username: "kgfk_spb",
        email: "kgfk_spb@gov.spb.ru",
        uid: "980",
        ip: "187.213.162.19",
        day: "4",
        week: "11",
        month: "51 ",
        status:  getRandomInt(100)
    },
    {
        username: "zhil_kom_spb",
        email: "zhil_kom_spb@gov.spb.ru",
        uid: "979",
        ip: "42.193.3.91",
        day: "2",
        week: "25",
        month: "93 ",
        status:  getRandomInt(100)
    },
    {
        username: "arhi_kom_spb",
        email: "arhi_kom_spb@gov.spb.ru",
        uid: "978",
        ip: "27.130.72.19",
        day: "2",
        week: "12",
        month: "75 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_cent_spb",
        email: "admin_cent_spb@gov.spb.ru",
        uid: "977",
        ip: "183.109.22.255",
        day: "3",
        week: "14",
        month: "75 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_frunz_spb",
        email: "admin_frunz_spb@gov.spb.ru",
        uid: "976",
        ip: "133.126.116.114",
        day: "2",
        week: "16",
        month: "112 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_pusk_spb",
        email: "admin_pusk_spb@gov.spb.ru",
        uid: "975",
        ip: "22.118.92.8",
        day: "4",
        week: "10",
        month: "21 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_primor_spb",
        email: "admin_primor_spb@gov.spb.ru",
        uid: "974",
        ip: "85.150.68.114",
        day: "4",
        week: "24",
        month: "85 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_petr_spb",
        email: "admin_petr_spb@gov.spb.ru",
        uid: "972",
        ip: "28.65.219.2",
        day: "4",
        week: "26",
        month: "58 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_nevsk_spb",
        email: "admin_nevsk_spb@gov.spb.ru",
        uid: "971",
        ip: "204.170.109.92",
        day: "3",
        week: "32",
        month: "115",
        status:  getRandomInt(100)
    },
    {
        username: "admin_mosk_spb",
        email: "admin_mosk_spb@gov.spb.ru",
        uid: "970",
        ip: "222.126.100.222",
        day: "3",
        week: "14",
        month: "25 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_kurort_spb",
        email: "admin_kurort_spb@gov.spb.ru",
        uid: "969",
        ip: "241.134.61.53",
        day: "4",
        week: "34",
        month: "81 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_kron_spb",
        email: "admin_kron_spb@gov.spb.ru",
        uid: "968",
        ip: "224.16.205.189",
        day: "5",
        week: "26",
        month: "71 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_krasnosel_spb",
        email: "admin_krasnosel_spb@gov.spb.ru",
        uid: "967",
        ip: "79.2.41.73",
        day: "2",
        week: "8",
        month: "91 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_kolpin_spb",
        email: "admin_kolpin_spb@gov.spb.ru",
        uid: "965",
        ip: "193.103.140.42",
        day: "4",
        week: "10",
        month: "72 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_kirov_spb",
        email: "admin_kirov_spb@gov.spb.ru",
        uid: "964",
        ip: "229.92.176.81",
        day: "4",
        week: "9",
        month: "86 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_kalin_spb",
        email: "admin_kalin_spb@gov.spb.ru",
        uid: "963",
        ip: "195.90.158.185",
        day: "4",
        week: "8",
        month: "83 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_vibor_spb",
        email: "admin_vibor_spb@gov.spb.ru",
        uid: "962",
        ip: "192.224.145.88",
        day: "2",
        week: "14",
        month: "87 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_vasil_spb",
        email: "admin_vasil_spb@gov.spb.ru",
        uid: "961",
        ip: "240.186.210.61",
        day: "2",
        week: "18",
        month: "124 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_admiral_spb",
        email: "admin_admiral_spb@gov.spb.ru",
        uid: "960",
        ip: "23.66.117.155",
        day: "4",
        week: "17",
        month: "52 ",
        status:  getRandomInt(100)
    },
    {
        username: "admin_gub_spb",
        email: "admin_gub_spb@gov.spb.ru",
        uid: "959",
        ip: "178.29.193.254",
        day: "4",
        week: "6",
        month: "89 ",
        status:  getRandomInt(100)
    },
    {
        username: "kio_spb",
        email: "kio_spb@gov.spb.ru",
        uid: "955",
        ip: "238.80.167.8",
        day: "5",
        week: "9",
        month: "92 ",
        status:  getRandomInt(100)
    },
    {
        username: "sht",
        email: "sht@kis.gov.spb.ru",
        uid: "887",
        ip: "7.169.35.175",
        day: "4",
        week: "13",
        month: "93 ",
        status:  getRandomInt(100)
    },
    {
        username: "am",
        email: "am@kis.gov.spb.ru",
        uid: "885",
        ip: "124.217.117.28",
        day: "2",
        week: "34",
        month: "44 ",
        status:  getRandomInt(100)
    },
    {
        username: "br",
        email: "br@kis.gov.spb.ru",
        uid: "884",
        ip: "204.226.67.254",
        day: "4",
        week: "31",
        month: "52 ",
        status:  getRandomInt(100)
    },
    {
        username: "tx",
        email: "tx@kis.gov.spb.ru",
        uid: "883",
        ip: "245.230.68.65",
        day: "5",
        week: "34",
        month: "57 ",
        status:  getRandomInt(100)
    },
    {
        username: "bg",
        email: "bg@kis.gov.spb.ru",
        uid: "882",
        ip: "174.171.195.11",
        day: "2",
        week: "8",
        month: "101 ",
        status:  getRandomInt(100)
    },
    {
        username: "gub",
        email: "gub@kis.gov.spb.ru",
        uid: "881",
        ip: "110.178.142.235",
        day: "3",
        week: "34",
        month: "79 ",
        status:  getRandomInt(100)
    },
    {
        username: "mv",
        email: "mv@kis.gov.spb.ru",
        uid: "879",
        ip: "192.19.238.31",
        day: "5",
        week: "21",
        month: "78",
        status:  getRandomInt(100)
    },
        {
        username: "vg_kis",
        email: "vg@kis.gov.spb.ru",
        uid: "878",
        ip: "230.240.63.29",
        day: "3",
        week: "6",
        month: "28 ",
        status:  getRandomInt(100)
    },
    {
        username: "chamara",
        email: "chamara@kis.gov.spb.ru",
        uid: "877",
        ip: "215.154.77.99",
        day: "1",
        week: "14",
        month: "78",
        status:  getRandomInt(100)
    },
  ]*/
      };
    },
    computed: {
      ...mapGetters([
        "isAdmin",
        "usersLogin"
      ]),
    },
    methods: {
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
      diffTime (int) {
        let randomDate = new Date()
        randomDate.setDate(randomDate.getDate() - int[0]);
        randomDate.setHours(int[1], getRandomTime(60), getRandomTime(60));
        return randomDate
      }
    },
    components: {
      UserInfo,
      UserInfoSimple,
    },
    mounted() {
      this.$store.dispatch(GET_USERS);
      this.$store.dispatch(GET_USERS_LOGIN);
    }
  };
</script>
<style>
 .search .el-input__inner{
    height: 40px;
    width: 85vw;
    max-width: 400px;
 }
   .el-table_1_column_4 .cell {
    text-align: center!important;
  }
 @media screen and (max-width: 480px) {
  .el-table{
      font-size: 10px;
  }
  .el-table .cell, .el-table th>.cell{
      padding-left: 5px;
      padding-right: 5px;
      word-break: break-word;
      line-height: unset;
  }
  .el-table__expanded-cell[class*=cell] {
      padding: 0px;
  }
  .el-form-item__label{
    font-size: 10px;
    line-height: unset;
  }
  .el-form-item {
    margin-bottom: 11px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-drawer__header{
    margin-bottom: 0;
  }
  .full-screen{
    position: absolute;
    left: 0;
    right: 0;
  }
  .search{
    padding: 20px;
  }
 }
</style>
